import { Form as FormV3 } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';

export default FormV3;
